import VocabInfoTip from "./VocabInfoTip";

export default function DictionarySourcePanel({
  label,
  siteName,
  result,
  infoTooltip,
  infoAriaLabel,
  idleMessage = "Le résultat s'affichera ici après la recherche.",
}) {
  return (
    <div className="capture-de-mot__dictionary-source">
      <div className="capture-de-mot__dictionary-source-label">
        <span>{label}</span>
        {infoTooltip ? (
          <VocabInfoTip
            className="capture-de-mot__dictionary-source-info"
            tooltip={infoTooltip}
            ariaLabel={infoAriaLabel || `À propos de ${siteName}`}
          />
        ) : null}
      </div>
      <div className="capture-de-mot__dictionary-frame capture-de-mot__dictionary-frame--selectable">
        {result.status === "idle" && (
          <p className="capture-de-mot__dictionary-placeholder">{idleMessage}</p>
        )}

        {result.status === "loading" && (
          <p className="capture-de-mot__dictionary-placeholder">Recherche en cours…</p>
        )}

        {(result.status === "not-found" || result.status === "error") && (
          <p className="capture-de-mot__dictionary-text capture-de-mot__dictionary-text--muted">
            {result.text}
          </p>
        )}

        {result.status === "success" && (
          <>
            <p className="capture-de-mot__dictionary-heading">{result.title}</p>
            <div className="capture-de-mot__dictionary-text">{result.text}</div>
            {result.url && (
              <a
                className="capture-de-mot__dictionary-link"
                href={result.url}
                target="_blank"
                rel="noopener noreferrer"
              >
                Voir sur {siteName}
              </a>
            )}
          </>
        )}
      </div>
    </div>
  );
}
